import $ from 'jquery';
import defaults from 'defaults';
import common from 'common';
import header from 'header';
import slider from 'slider';
import tab from 'tab';
import navigation from 'navigation';
import modal from 'modal';
import contact from 'contact';
import top from 'top';

let JMAC = JMAC || {
  isMobile  : true,
  ua        : {},
  scrollpos : 0,
  currentWidth : 0
};

$(window).on('resize', function(){
  if (JMAC.currentWidth === window.innerWidth) {
    return;
  }

  JMAC.isMobile = defaults.setIsMobile();
  JMAC.ua       = defaults.setUa();

  defaults.setViewport(JMAC.ua,1400);
  navigation.setPageNavigation(JMAC);
});

$(window).on('scroll', function(){
  let _scroll = $(this).scrollTop();
  header.setFixedMenu(_scroll);
  defaults.setToTop(_scroll);
});

$(function(){
  JMAC.isMobile = defaults.setIsMobile();
  JMAC.ua       = defaults.setUa();

  if (JMAC.isMobile) {
    defaults.setAnchor(70);
  } else {
    defaults.setAnchor(65);
  }

  defaults.setViewport(JMAC.ua,1400);
  common.setAccordion();
  header.setSpMenu(JMAC);
  header.setPcMenu(JMAC);
  tab.setTabs(JMAC.ua);
  navigation.setPageNavigation(JMAC);
  navigation.setSubNavigation();
  navigation.setSeminarChoice();
  modal.movieModal();
  contact.setContactData();
  contact.setLink();

  slider.setBannerSlider();
  slider.setNewsSlider();
  slider.setMegaHeadingSlider();

  top.setIcon();
});



// WEBPACK FOOTER //
// ./src/js/script.js